module.exports = __webpack_public_path__ + "static/media/flag(ua).5baf6149.svg";